import styled from 'styled-components'

export const SearchContainer = styled.div`
  display: flex;
  svg {
    margin-left: 30px;
    position: absolute;
    width: 24px;
    height: 24px;
    margin-top: 10px;
  }
`

export const SearchInput = styled.input.attrs({
  type: 'text',
})`
  padding-left: 65px;
  padding-right: 9vw;
  margin-right: 10px;
  height: 42px;
  position: relative;
  max-width: 500px;
  border-radius: 100px;
  border: none;
  box-shadow: 0px 3.5px 11px 2px #e7effd;
  ::placeholder {
    color: #343f4b;
    font-size: 16px;
    font-family: Roboto;
  }
`
